var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMineIcon4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_42_1457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4 7.55556H20.1C20.3387 7.55556 20.5676 7.64921 20.7364 7.81591C20.9052 7.9826 21 8.2087 21 8.44444V19.1111C21 19.3469 20.9052 19.573 20.7364 19.7397C20.5676 19.9064 20.3387 20 20.1 20H3.9C3.66131 20 3.43239 19.9064 3.2636 19.7397C3.09482 19.573 3 19.3469 3 19.1111V4.88889C3 4.65314 3.09482 4.42705 3.2636 4.26035C3.43239 4.09365 3.66131 4 3.9 4H17.4V7.55556ZM4.8 9.33333V18.2222H19.2V9.33333H4.8ZM4.8 5.77778V7.55556H15.6V5.77778H4.8ZM14.7 12.8889H17.4V14.6667H14.7V12.8889Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_42_1457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMineIcon4);
export default __webpack_public_path__ + "static/media/mine-icon4.a9dc940f3e2bab21538617e3c34e8b8e.svg";
export { ForwardRef as ReactComponent };